export var na1 = 'na1';
export var test2 = 'test2';
export var eu1 = 'eu1';